import * as yup from 'yup'

function addEmptyMethod<T extends yup.Schema>(schema: T, message: string) {
  return schema.nullable().test({
    name: 'empty',
    message,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    test: (value: any) => value === null || value === undefined || value === ''
  })
}

yup.addMethod(yup.mixed, 'empty', function (message = 'Field should be empty') {
  return addEmptyMethod(this, message)
})
